import React from 'react';

import { Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

const title = 'Where to post this listing';
const description =
  'Zillow Rental Network sites include HotPads, Trulia, Zillow. Housing Connector will share your listing with nonprofit agencies and display the modified screening criteria that you specified.';

const propTypes = {};
const defaultProps = {};

const HousingConnectorContent = () => (
  <div data-testid="HousingConnectorContent">
    <Text
      textStyle="heading-sm"
      css={{
        marginBottom: '200',
        md: {
          marginBottom: '400',
        },
      }}
      asChild
    >
      <p>{title}</p>
    </Text>

    <Spacer marginBottom="sm">
      <Text asChild>
        <p>{description}</p>
      </Text>
    </Spacer>
  </div>
);

HousingConnectorContent.propTypes = propTypes;
HousingConnectorContent.defaultProps = defaultProps;

export default HousingConnectorContent;
